import createVueApp from '@phoenix/createVueApp';

import PhxsgLightbox from './phxsg-lightbox.vue';

document.querySelectorAll('[data-component="phxsg-lightbox"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgLightbox', PhxsgLightbox);
  const wrapper = document.createElement('div');
  wrapper.style.display = 'contents';
  el.parentNode?.insertBefore(wrapper, el);
  wrapper.appendChild(el);
  app.mount(wrapper);
});
